import { beSetupAxiosInstance } from '../../axios/beSetupAxios';
import { collectionSetupAxiosInstance } from '../../axios/collectionSetupAxios';
import { GenerateReportTaskType } from './reportThunk';

const getReportListing = async (requestData: any) => {
  const body = {
    filters: requestData.params?.filters,
    search: requestData.params?.search,
    sortField: requestData.params?.sortField,
    sortOrder: requestData.params?.sortOrder,
    currentPage: requestData.params?.pagination.current,
    pageSize: requestData.params?.pagination.pageSize,
  };
  const result = await collectionSetupAxiosInstance.post(
    `/redCash/api/v1.0/report/getReportList/reportType/${requestData.params?.reportType}`,
    body
  );
  return result.data;
};

const downloadReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/getFile/${requestData.id}`,
    { responseType: 'blob' }
  );
  return result.data;
};

const getManualPaymentTemplate = async (requestData: any) => {
  const result = await beSetupAxiosInstance.get(`/redCash/api/v1.0/payment/downloadTemplate`, {
    responseType: 'blob',
  });
  return result.data;
};

const generateMasterListingReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateMasterListingReport/reportDate/${requestData.reportDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateCollectionReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/collectionReport/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateKpktReport = async (requestData: any) => {
  const result = await beSetupAxiosInstance.get(
    `/redCash/admin/api/v1.0/report/kpkt/startDate/${requestData.startDate}/endDate/${requestData.endDate}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateInterestChargesReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateInterestCharges/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateMiscBillingReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateMiscChargeReport/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateLoanMaturityReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateLoanMaturity/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateOverDueReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateOverDue/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateLoanCncReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateLoanCNC/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateInterestCncReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateInterestCNC/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateLateChargesReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateLateCharges/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generatePartnerReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/partnerInfo/startDate/${requestData.startDate}/endDate/${requestData.endDate}/financingType/${requestData.financingType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateAgingReport = async (requestData: any) => {
  const query = {
    startDate: requestData.startDate,
    email: requestData.email,
    isSave: requestData.isSave,
  };
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/agingReport/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { params: query, responseType: 'blob' }
  );

  return result.data;
};

const generateCustomerDetailsReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/customerDetailsReport/startDate/${requestData.startDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateStampDutyReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/stampDutyReport/reportDate/${requestData.reportDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateConsolidatedEInvoiceDetailsReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/consolidatedEInvoiceDetailsReport/v2/einvoice/${requestData.einvoiceId}`,
    { responseType: 'blob' }
  );

  return result.data;
};

const generateConsolidatedCreditNoteDetailsReport = async (requestData: any) => {
  const { id } = requestData;
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/consolidatedCreditNoteDetailsReport/v2/einvoice/${id}`,
    { responseType: 'blob' }
  );

  return result.data;
};

export const generateLoanInsuranceReport = async (requestData: any) => {
  const result = await beSetupAxiosInstance.get(
    `/redCash/admin/api/v1.0/report/loanInsuranceReport`,
    {
      params: requestData,
    }
  );

  return result.data;
};

export const generateSmeMonthlyDeductionReport = async (requestData: any) => {
  const params = { email: requestData.email };
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/generateSmeMonthlyDeductionReport/reportDate/${requestData.reportDate}/loanType/${requestData.loanType}`,
    { params }
  );

  return result.data;
};

export const generateWaiverReport = async (requestData: any) => {
  const result = await collectionSetupAxiosInstance.get(
    `/redCash/api/v1.0/report/waiver/reportDate/${requestData.reportDate}/financingType/${requestData.financingType}/loanType/${requestData.loanType}`,
    { responseType: 'blob' }
  );

  return result.data;
};

export const generateReportTask = async (requestData: GenerateReportTaskType) => {
  const url = `/redCash/api/v1.0/report/generateReportTask`;
  const res = await collectionSetupAxiosInstance.post(url, requestData);
  return res.data;
};

const reportService = {
  getReportListing,
  downloadReport,
  getManualPaymentTemplate,
  generateMasterListingReport,
  generateCollectionReport,
  generateKpktReport,
  generateInterestChargesReport,
  generateMiscBillingReport,
  generateLoanMaturityReport,
  generateOverDueReport,
  generateLoanCncReport,
  generateInterestCncReport,
  generateLateChargesReport,
  generatePartnerReport,
  generateAgingReport,
  generateCustomerDetailsReport,
  generateStampDutyReport,
  generateConsolidatedEInvoiceDetailsReport,
  generateConsolidatedCreditNoteDetailsReport,
  generateLoanInsuranceReport,
  generateSmeMonthlyDeductionReport,
  generateWaiverReport,
  generateReportTask,
};
export default reportService;
